import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { parseFilters } from '@/services/parsing_services/filter-service';
import isObject from 'lodash/isObject';
import get from 'lodash/get';

const _byResourcename = (name) => (item) => item.resourcename == name;
const isEventEmpty = (event) =>
  event == undefined || event.length == 0 || event == '';

const FILTER = 'resourcesingle';

export default {
  props: {
    lookALikeFilter: { type: [Array, Object]},
    resourceSinglePath: { type: String, default: `filters.${FILTER}`}
  },
  data() {
    return {
      params: {}
    };
  },
  computed: {
    ...mapGetters('tableStore', ['getTable']),
    internalValue() {
      let filter = this.filterObject?.find(_byResourcename(this.input.model));
      return isEventEmpty(filter?.value)
        ? undefined
        : filter?.value?.split(';');
    },
    resourceSingleFilter() {
      if (this.lookALikeFilter != undefined && this.resourceSinglePath != undefined) {
        return get(this.lookALikeFilter, this.resourceSinglePath)
      }
      return this.getTable(this.$route)?.filters[FILTER];
    },
    filterObject() {
      let filter = this.resourceSingleFilter ?? [];
      return filter?.map((item) => ({
        resourcename: item.slice(0, item.indexOf(':')),
        value: item.slice(item.indexOf(':') + 1),
      }));
    },
    watchParams() {
      return this.input?.props?.watchParams;
  },
  },
  methods: {
    handleInput(event) {
      let clonedFilterObject = cloneDeep(this.filterObject);
      let resourcename = this.input.model;

      let index = clonedFilterObject.findIndex(_byResourcename(resourcename));
      let currentFilterByResourceName = clonedFilterObject[index];

      if (!currentFilterByResourceName && (event?.length == 0 || !event)) return

      let parsedVal = event.map(val => {
        if (isObject(val)) return String(get(val, this.input.props.itemValue ?? 'id'))
        return val
      })

      if (index >= 0) {
        if (isEventEmpty(event)) clonedFilterObject.splice(index, 1);
        else {
          clonedFilterObject[index].value = parsedVal;
        }
      } else if (!isEventEmpty(event)) {
        clonedFilterObject.push({ resourcename, value: parsedVal });
      }

      let newConcatValue =
        clonedFilterObject.length == 0
          ? undefined
          : clonedFilterObject?.map((item) => {
              let val = item.value;
              if (Array.isArray(val)) val = val?.join(';');
              return `${item.resourcename}:${val}`;
            });

      return this.$emit('input', {
        preventDefault: true,
        searchKeyOverride: FILTER,
        value: newConcatValue,
      });
    },
  },
  watch: {
    filterObject() {
      if (this.watchParams) {
        let filter = {};
        this.watchParams.forEach((param) => {
          let internalData = this.filterObject?.find(_byResourcename(param.model));
          if (internalData && internalData?.value) 
            filter = {
              ...filter,
              ...parseFilters(param.getParams([internalData?.value]))
            };
        });
        this.params = filter;
      }
    },
  },
};